import Icon from "assets/icons";
import classNames from "classnames";
import Input from "shared/form/core/input";
import { useCopies } from "shared/hooks/useCopies";
import useSearchWrapperService from "./service";
import { SearchWrapperArgsType } from "./type";
import Button from "../button";

export default function SearchWrapper(props: SearchWrapperArgsType) {
  const copies = useCopies();
  const service = useSearchWrapperService(props);

  return (
    <div
      className={classNames("searchWrapper", {
        compactStyle: props.compactStyle,
        "searchWrapper--disabled": props.disabled
      })}>
      <div className="searchWrapper_search">
        <div className={classNames("searchWrapper_searchField", { showClear: service.searchText?.trim() })}>
          {!props.manualSearchTrigger && (
            <span className={classNames("searchWrapper_searchIcon")}>
              <Icon.Search size={16} />
            </span>
          )}
          <Input
            innerRef={service.searchRef}
            className="searchWrapper_searchInput"
            type="text"
            name={"search"}
            onChange={service.changeHandler}
            value={service.searchText || ""}
            disabled={props.disabled}
            placeholder={props.hidePlaceholder ? "" : props.placeholder || copies.get("search")}
            onKeyDown={service.keyDownHandler}
          />
          <div className="searchWrapper_searchActions">
            {service.searchApplied && (
              <Button
                className={classNames("searchWrapper_searchClear")}
                tooltipContent={copies.get("search.input.clear.result.tooltip")}
                icon={<Icon.Close size={16} />}
                onClick={service.clearHandler}
              />
            )}
            {props.manualSearchTrigger && (
              <Button
                className={classNames("searchWrapper_searchButton")}
                title={copies.get("search")}
                icon={<Icon.Search size={16} />}
                onClick={service.searchIconClickHandler}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
